import { useState, useEffect } from 'react';
import { adminApi } from '@/utils/api';

export const TableViewer = ({ tableName }: { tableName: string }) => {
    const [rows, setRows] = useState<any[]>([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState<string | null>(null);

    useEffect(() => {
        setLoading(true);
        setError(null);
        adminApi.getTableData(tableName)
            .then(async res => {
                const text = await res.text();
                if (!res.ok) throw new Error(`Server Error: ${res.status} ${res.statusText}`);
                try { return JSON.parse(text); } catch (e) { throw new Error("Invalid Server Response (Not JSON)"); }
            })
            .then(data => { if (data.success) setRows(data.rows); else setError(data.error); })
            .catch(err => setError(err.message))
            .finally(() => setLoading(false));
    }, [tableName]);

    if (loading) return <div className="p-4 text-center text-xs text-white/40">Loading data...</div>;
    if (error) return <div className="p-4 text-center text-xs text-red-400">Error: {error}</div>;
    if (rows.length === 0) return <div className="p-4 text-center text-xs text-white/40">Table is empty.</div>;

    const keys = Object.keys(rows[0]);

    return (
        <div className="w-full overflow-x-auto">
            <table className="w-full text-left text-[10px] font-mono whitespace-nowrap">
                <thead className="bg-white/5 text-white/40 border-b border-white/5">
                    <tr>{keys.map(k => <th key={k} className="p-2 font-bold uppercase">{k}</th>)}</tr>
                </thead>
                <tbody className="divide-y divide-white/5">
                    {rows.map((row, i) => (
                        <tr key={i} className="hover:bg-white/5">
                            {keys.map(k => {
                                let val = row[k];
                                if (typeof val === 'object' && val !== null) val = JSON.stringify(val).substring(0, 20) + '...';
                                else if (String(val).length > 50) val = String(val).substring(0, 50) + '...';
                                return <td key={k} className="p-2 text-white/60">{val}</td>;
                            })}
                        </tr>
                    ))}
                </tbody>
            </table>
        </div>
    );
};
